module.exports = __webpack_public_path__ + "media/images/articles/entry_steps/img01-0be67fa52197f831dd74342a07d03993.png";